import React, { useState } from "react";

interface Props {
  descriptionText: string;
  customClass?: string;
  numOfLines?: number;
}

const DescriptionText = (props: Props) => {
  const [showMore, setShowMore] = useState(false); // show full description
  const { descriptionText, customClass = "", numOfLines = 2 } = props;
  return (
    <p
      className={`${
        showMore ? "" : `line-clamp-${numOfLines}`
      } text-14 text-black/50 whitespace-pre-wrap cursor-pointer ${
        customClass || ""
      }`}
      onClick={() => setShowMore((prevShowMore) => !prevShowMore)}
    >
      {descriptionText}
    </p>
  );
};

export default DescriptionText;
